export default __webpack_public_path__ + "static/media/mir.3d8fd6f9.svg";